/*
 * PRD-037 — Capa de datos del paso de plan del claim (app SEPARADA del panel).
 *
 * El portal del partner NO monta Redux ni el AuthContext del panel, así que los hooks del panel
 * (useAvailableSubscriptions, useActivatePlan) NO funcionan aquí: usan useSelector / useAuth y
 * crashearían sin sus providers. En su lugar replicamos sus DOS llamadas contra los MISMOS
 * endpoints usando axiosInstance directo: su interceptor de request inyecta el JWT de comercio +
 * el header id_comercio leyéndolos de localStorage (ver axiosInstance.ts) — justo lo que persiste
 * ClaimPage tras el claim. Así el authorizer del gateway recibe los headers que espera, sin
 * arrastrar los providers del panel ni romper el patrón de app separada.
 *
 * Reusamos los CONTRATOS de tipo del panel (import type, cero runtime) para no duplicar la forma:
 * - AvailableSubscription: lo que devuelve GET /v1/planes.
 * - ActivatePlanResponse / MetodoPago: el contrato de convertFreemium (FR-28).
 */
import axiosInstance from '@services/axiosInstance';
import type { AvailableSubscription } from '@interfaces/general';
import type { ActivatePlanResponse, MetodoPago } from '@pages/Subscriptionsv2/hooks/useActivatePlan';

// GET /v1/planes — mismos planes públicos (is_public) que muestra el panel (useAvailableSubscriptions).
export const fetchPublicPlans = async (): Promise<AvailableSubscription[]> => {
  const { data } = await axiosInstance.get<AvailableSubscription[]>('/v1/planes');
  return data;
};

// POST /v1/suscriptions/convertFreemium — el dueño recién reclamado es FREEMIUM, así que SIEMPRE
// es la rama convertFreemium de useActivatePlan (nunca createSubscription). El backend mapea
// metodo_pago: 'tarjeta' → { client_secret } (Stripe Elements + 3DS); 'transferencia' →
// { hosted_invoice_url }. Mismo contrato que el panel.
export const convertFreemiumToPlan = async (planId: string, metodoPago: MetodoPago): Promise<ActivatePlanResponse> => {
  const { data } = await axiosInstance.post<ActivatePlanResponse>('/v1/suscriptions/convertFreemium', {
    plan_id: planId,
    metodo_pago: metodoPago,
  });
  return data;
};
